import Echo from "laravel-echo";
import Alpine from "alpinejs";
import photoQcValidation from './components/photoQcValidation.js';

window._ = require("lodash");
try {
    window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");
    require("bootstrap");
} catch (e) {}

window.Pusher = require("pusher-js");
window.Echo = new Echo({
    broadcaster: "pusher",
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true,
});

Alpine.data('photoQcValidation', photoQcValidation);
window.Alpine = Alpine;
Alpine.start();
